import { useState, useEffect } from "react";
import { Menu } from "lucide-react";
import { Wordmark, DesktopNav, MobileMenu } from "./nav/NavParts";

export default function Nav({ theme = "light" }) {
  const dark = theme === "dark";
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  const ink = dark ? "text-[#ece7db]" : "text-[#23211c]";
  const muted = dark ? "text-[#928c7d]" : "text-[#8b8578]";

  return (
    <header className={`w-full ${ink}`} data-testid="site-nav">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-6 md:py-8 flex items-start justify-between">
        <Wordmark muted={muted} />
        <DesktopNav dark={dark} ink={ink} muted={muted} />
        <button className="md:hidden mt-1" onClick={() => setOpen(true)} aria-label="Open menu" data-testid="mobile-menu-open">
          <Menu className="w-6 h-6" strokeWidth={1.5} />
        </button>
      </div>
      {open && <MobileMenu onClose={() => setOpen(false)} />}
    </header>
  );
}
